module.exports = __webpack_public_path__ + "signInBanner.33a487996dc81935ef77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/signInBanner.jpg
// module id = 1397
// module chunks = 32